import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/layer/review/requeue/layer.review.requeue.mutation.gql"
import type {
  LayerReviewRequeueMutation,
  LayerReviewRequeueMutationVariables,
} from "@/v2-backoffice-client/layer/review/requeue/__types__/layer.review.requeue.mutation"

type Options = MutationHookOptions<
  LayerReviewRequeueMutation,
  LayerReviewRequeueMutationVariables
>

export function useLayerReviewRequeueMutation(options?: Options) {
  return useMutation<
    LayerReviewRequeueMutation,
    LayerReviewRequeueMutationVariables
  >(mutation, options)
}
